/**
 * UserActivity Component
 *
 * Features:
 * - Displays user's activity and coevaluation results.
 * - Allows switching between average and individual coevaluations.
 * - Handles PDF modal view for activity file.
 * - Uses Redux for lesson info and i18next for translations.
 * - Utilizes Material-UI Button for UI actions.
 * - Uses CSS modules for styling.
 */
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import Button from '@mui/material/Button';

import AVGCoevaluation from '../AVGCoevaluation/AVGCoevaluation';
import IndividualCoevaluation from '../IndividualCoevaluation/IndividualCoevaluation';
import ModalViewPDF from 'components/UI/ModalViewPDF/ModalViewPDF';
import classes from './UserActivity.module.css';

const UserActivity = () => {
  const { t } = useTranslation(['lesson']);
  // State to indicate if the data is loading
  const [isLoading, setIsLoading] = useState(true);
  // Redux selector for lesson info
  const dataLesson = useSelector(state => state.lessonInfo);
  // State to toggle between average and individual coevaluation views
  const [AVGView, setAVGView] = useState(true);
  // State to control the PDF modal visibility
  const [openActivity, setOpenActivity] = useState(false);
  // State to store the activity PDF URL
  const [urlActivity, setUrlActivity] = useState('');

  useEffect(() => {
    if (dataLesson.coevaluationsHomeWork !== null) {
      setIsLoading(false);
    }
  }, [dataLesson.coevaluationsHomeWork]);

  const openActivityHandler = url => () => {
    setOpenActivity(true);
    setUrlActivity(url);
  };

  const closeActivityHandler = () => {
    setOpenActivity(false);
  };

  const changeView = () => {
    setAVGView(!AVGView);
  };

  return (
    <>
      {!isLoading && (
        <div className={classes.activityContainer}>
          <p className={classes.title}>
            {dataLesson.homework.title}
          </p>
          <Button
            className={classes.btnActivity}
            onClick={openActivityHandler(dataLesson.homework.path)}
          >
            {t('see_my_activity')}
          </Button>
          {dataLesson.coevaluationsHomeWork.length > 0 && (
            <>
              <Button
                className={classes.btnActivity}
                onClick={changeView}
              >
                {AVGView
                  ? 'Ver evaluaciones individuales'
                  : 'Ver calificación promedio'}
              </Button>
              {AVGView ? (
                <AVGCoevaluation />
              ) : (
                <IndividualCoevaluation />
              )}
            </>
          )}

          {dataLesson.coevaluationsHomeWork.length === 0 && (
            <p>{t('no_average_grades')}</p>
          )}
        </div>
      )}
      {/* Props passed to ModalViewPDF:
          - urlCloudFront: urlActivity
          - openModal: openActivity
          - onCloseModal: closeActivityHandler
          - urlViewPDF: urlActivity
          - titlePDF: dataLesson.homework.title
      */}
      <ModalViewPDF
        urlCloudFront={urlActivity}
        openModal={openActivity}
        onCloseModal={closeActivityHandler}
        urlViewPDF={urlActivity}
        titlePDF={dataLesson.homework.title}
      />
    </>
  );
};

export default UserActivity;
